import React, { useCallback, useEffect, useState } from 'react';
import { exportToCSV } from 'components/Common/CSVManage';
import { useSnackbar } from 'notistack';
import { fileHandler, mapRowData } from 'utils/excelRenderer';
import { useDropzone, FileWithPath } from 'react-dropzone';

interface IStepProps {
  setTemplate: any;
  type: string,
  setType: any;
  setFile: any;
  rows: any;
  setRows: any;
  setCols: any;
  rowData: any[];
  setRowData: any
  file: FileWithPath | undefined;
  cur_user: any;
  template: string[];
  selectedSourceBox: number;
  email?: string;
  setEmail?: any;
  setColsArr?: any;
  inputs?: any;
  setInputs?: any;
  _id?: string;
  cur_case: any;
  tab?: any;
  setTab?: any;
}

const FileStep: React.FC<IStepProps> = ({ template, setTemplate, type, setType, file, setFile, rows, setRows, setCols, rowData, setRowData, cur_user, selectedSourceBox, email, setEmail, setColsArr, _id, cur_case, inputs, setInputs, tab, setTab }) => {
  const { enqueueSnackbar } = useSnackbar();


  const entityHeaders = [
    'Importer of Record Name',
    'Importer of Record',
    'Exporter Name',
    'Buyer Name',
    'Seller Name',
    'Manufacturer Name',
    'Ship To Party',
    'Consolidator (Stuffer) Name',
    'Vessel Name',
    'Carrier\'s Information',
    'Company Legal Name',
    'Parent Company (If applicable)',
    'Company Identification Number',
    'Contact Person Information',
    'Company Website',
    'Zone Approval Officer',
    'Vessel Name or Aircraft',
    'Name of Facility',
    'Contact Name',
    'Parent Company',
    'Facility Owners',
    'Subcontractors (If Applicable)',
    'Customs Broker Name',
    'Carrier Contact Name',
    'Carrier Name',
    'Consignee Contact Name',
    'Consignee Company Name',
    'Consignee Address',
    'Shipper Email',
    'Shipper Contact Name',
    'Shipper Company Name',
    'Shipper Address',

  ];
  const codeHeaders = [
    'Commodity Harmonized Tariff Schedule Number (HTS)',
    'HS Code',
    'HS Code(s)',
    'Item'
  ];
  const descHeaders = [
    'Product Detailed Information',
    'Description of Merchandise',
    'Item',
    'Assembly Name or Number',
    'Sub Assembly Name or Number',
    'Component / Part Name',
    'Part Number',
    'Description',
    'Description of Goods'
  ];
  const countryHeaders = [
    'Country of Origin'
  ];

  const handleTabSwitch = (val: string) => {
    switch (val) {
    case 'Entity':
      setTab('Entity');
      break;
    case 'Products':
      setTab('Products');
      break;
    default:
      setTab('Entity');
    }
  };

  const mapType = (header: string) => {
    if (cur_case?.colMapping?.length > 0) {
      const foundItem = cur_case.colMapping.find((item: any) => item.val === header);
      return foundItem ? foundItem.prop : undefined;
    }
    if (entityHeaders.includes(header)) {
      return 'entity';
    } else if (codeHeaders.includes(header)) {
      return 'code';
    } else if (descHeaders.includes(header)) {
      return 'desc';
    } else if (countryHeaders.includes(header)) {
      return 'country';
    }
    return 'exclude';
  };

  const supplierTemp = [ 'Name of Facility',	'Address of Facility',	'Contact Name',	'Contact Title',	'Parent Company', 'Facility Owners',	'Subcontractors (If Applicable)' ];


  const compareHeaders = (arr1: string[]) => {
    if (type === 'Bulk Screening' && selectedSourceBox === 1) {
      return true;
    } else if (arr1.length !== template.length) {
      return false;
    }


    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = template.slice().sort();

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    acceptedFiles.forEach(async(accptFile) => {
      const reader = new FileReader();
      reader.onabort = () => {
        enqueueSnackbar('File reading aborted', { variant: 'info' });
      };
      reader.onerror = () => {
        enqueueSnackbar('Error reading file', { variant: 'error' });
      };

      setFile(accptFile);

      const { rows } = await fileHandler(accptFile);
      const colNames: string[] = rows[0];

      const tempCheck = compareHeaders(colNames);
      if (rows.length > 21) {
        enqueueSnackbar('Your file has too many rows. Please upload a file that has 20 or less rows of values.', { variant: 'error' });
        setFile(undefined);
        return;
      } else if (tempCheck) {
        const fileRowData = rows.slice(1);
        const mappedRowData = mapRowData(colNames, fileRowData);
        setRows(mappedRowData);
        setCols(colNames);
        if (type === 'Bulk Screening') {
          setTemplate(colNames);
          const colsArrofObjs: any[] = [];
          colNames.forEach((col: any) => {
            const obj = {
              prop: 'bulk',
              val: col,
            };
            colsArrofObjs.push(obj);
          });
          setColsArr(colsArrofObjs);
        }
      } else {
        enqueueSnackbar('Your file does not match your selected template. Please try again with the correct format', { variant: 'error' });
        setFile(undefined);
      }
    });
  }, [ type ]);

  const fileValidator = (file: any) => {
    if (file.size > 20000000) {
      enqueueSnackbar('Your file is too large, upload a file less than 20mbs', { variant: 'error' });
      return {
        code: 'size-too-large',
        message: 'file is larger than 20MB',
      };
    }
    return null;
  };
  const removeFile = () => {
    setFile([]);
    setRows([]);
    setCols([]);
  };
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: onDrop,
    validator: fileValidator,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet , text/csv',
  });

  const valsArrofObjs: any = [];

  useEffect(() => {
    if (rows.length > 0) {
      rows.forEach((row: any, i: number) => {
        Object.keys(row).forEach((key) => {
          const obj = {
            type: mapType(key),
            searchVal: row[key],
            row: i
          };
          if (obj.type) {
            valsArrofObjs.push(obj);
          }
        });
      });
      setRowData(valsArrofObjs);
    } else {
      setRowData([]);
    }
  }, [ rows ]);

  const handleSendEmailChange = (value: string) => {
    setEmail(value);
  };

  const handleClearInput = (field: any) => {
    const onChangeValue = { ...inputs };
    onChangeValue[field] = '';
    setInputs(onChangeValue);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const onChangeValue = { ...inputs };
    onChangeValue[name] = value;
    setInputs(onChangeValue);
  };


  return(
    <>

      {selectedSourceBox === 1 && (
        <>
          <div className='bill-container-fit-screen-content-row'>
            <div className='bill-container-fit-screen-content-row-header'>
              <p>1. Upload Type</p>
            </div>
            <div className='monitor-doc-type'>
              <h1>Bulk Screening</h1>
            </div>
          </div>
          { type !== 'Bulk Screening' &&
            <div className='bill-container-fit-screen-content-row'>
              <div className='bill-container-fit-screen-content-row-header'>
                <p>2. Download Template</p>
              </div>
              <div className='bill-container-fit-screen-content-row-btn' onClick={() => exportToCSV(type, [], template)}>
                <div className='bill-container-fit-screen-content-row-btn-text'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
                    <path d='M6.5 9L9.5 12M9.5 12L12.5 9M9.5 12V6M17 9C17 13.1421 13.6421 16.5 9.5 16.5C5.35786 16.5 2 13.1421 2 9C2 4.85786 5.35786 1.5 9.5 1.5C13.6421 1.5 17 4.85786 17 9Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                  <p>Download Template</p>
                </div>
              </div>
            </div>
          }
          <div className='bill-container-fit-screen-content-row'>
            <div className='bill-container-fit-screen-content-row-header'>
              <p>{type === 'Bulk Screening' ? '2' : '3'}. Upload Document</p>
            </div>
            <div {...getRootProps()} style={{ width: '100%', cursor: 'pointer' }}>
              <div className={`files-container-empty ${file?.name ? 'file-uploaded' : ''}`}>
                {file?.name ? (<>
                  <p className='files-container-text'>
                    <span className='bill-container-fit-screen-content-row-highlight-blue cursor-pointer'>{file.name} </span>
                    <svg onClick={removeFile} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' cursor={'pointer'}>
                      <g id='trash-03'>
                        <path id='Icon' d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </g>
                    </svg>
                  </p>
                </>
                ) : (
                  <>
                    <p className='files-container-text'>
                      <span className='bill-container-fit-screen-content-row-highlight-blue cursor-pointer'>Click to upload</span> or drag and drop</p>
                    <p className='files-container-text'> CSV file format only (max 200 MB and 20 rows)</p>
                    <input {...getInputProps()} />
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {selectedSourceBox === 4 && (
        <>
          <div className='bill-container-fit-screen-content-row'>
            <div className='bill-container-fit-screen-content-row-header'>
              <p>1. Who is receiving this questionnaire?</p>
            </div>
            <div className='bill-container-fit-screen-content-dropdown-input-sec'>
              <input
                aria-disabled={Boolean(_id)} style={{ opacity: _id ? 0.5 : 1 }}
                placeholder='jsmith@email.com'
                value={email}
                className='bill-container-fit-screen-content-dropdown-input'
                disabled={Boolean(_id)}
                onChange={_id ? undefined : (e) => handleSendEmailChange(e.target.value)}/>
            </div>
          </div>
          <div className='bill-container-fit-screen-content-row'>
            <div className='bill-container-fit-screen-content-row-header'>
              <p>2. Download template if you would like to review</p>
            </div>

            <div className='bill-container-fit-screen-content-row-btn' onClick={() => exportToCSV('Supplier Questionnaire', [], supplierTemp)}>
              <div className='bill-container-fit-screen-content-row-btn-text'>
                <svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
                  <path d='M6.5 9L9.5 12M9.5 12L12.5 9M9.5 12V6M17 9C17 13.1421 13.6421 16.5 9.5 16.5C5.35786 16.5 2 13.1421 2 9C2 4.85786 5.35786 1.5 9.5 1.5C13.6421 1.5 17 4.85786 17 9Z' stroke='#E5F2FD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
                <p>Download Template</p>
              </div>
            </div>


          </div>
        </>
      )}
      {selectedSourceBox === 5 && (
        <>
          <div className='bill-container-fit-screen-content-row'>
            <div className='bill-container-fit-screen-content-row-header'>
              <p>1. Select Value Type</p>
            </div>
            <div className='home-search-frame-input-action'>
              <div className='home-search-frame-input-action-sec'>
                <div className='home-search-frame-input-action-cont-sec'>
                  <div onClick={() => handleTabSwitch('Entity')} className={`home-search-frame-input-action-cont-btn ${tab === 'Entity' ? 'selected' : ''}`}>People & Companies</div>
                  <div onClick={() => handleTabSwitch('Products')} className={`home-search-frame-input-action-cont-btn ${tab === 'Products' ? 'selected' : ''}`}>Products & HTS Codes</div>
                </div>
              </div>
            </div>
          </div>


          <div className='bill-container-fit-screen-content-row'>
            <div className='bill-container-fit-screen-content-row-header'>
              <p>2. Fill Values</p>
            </div>

            {tab === 'Entity' ?
              <div className='screening-input-group' style={{ marginTop: 0 }}>
                <div className='screening-input-field-container'>
                  <input
                    id='primary'
                    type='text'
                    placeholder='Required: Enter Person or Company Name'
                    className='screening-input-field-content'
                    name='primary'
                    value={inputs.primary}
                    onChange={(e) => handleChange(e)}
                  />
                  <svg onClick={() => handleClearInput('person')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
                <div className='screening-input-minors'>
                  <div className='screening-input-field-container' style={{ width: '35%' }}>
                    <input
                      id='country'
                      type='text'
                      placeholder='Optional: Enter Country'
                      className='screening-input-field-content'
                      name='country'
                      value={inputs.country}
                      onChange={(e) => handleChange(e)}

                    />
                    <svg onClick={() => handleClearInput('country')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                  <div className='screening-input-field-container' style={{ width: '65%' }}>
                    <input
                      id='address'
                      type='text'
                      placeholder='Optional: Enter Address'
                      className='screening-input-field-content'
                      name='address'
                      value={inputs.address}
                      onChange={(e) => handleChange(e)}

                    />
                    <svg onClick={() => handleClearInput('address')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                </div>
              </div> :
              <div className='screening-input-group' style={{ marginTop: 0 }}>
                <div className='screening-input-minors'>
                  <div className='screening-input-field-container' style={{ width: '35%' }}>
                    <input
                      id='hsCode'
                      type='text'
                      placeholder='Enter HTS Code'
                      className='screening-input-field-content'
                      name='hsCode'
                      value={inputs.hsCode}
                      onChange={(e) => handleChange(e)}

                    />
                    <svg onClick={() => handleClearInput('hsCode')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                  <div style={{ color: '#EFF1F6', fontFamily: 'Inter', fontSize: '16px', fontStyle: 'normal', fontWeight: 600, margin: 'auto' }}>Or</div>
                  <div className='screening-input-field-container' style={{ width: '65%' }}>
                    <input
                      id='desc'
                      type='text'
                      placeholder='Enter Product Name or Description'
                      className='screening-input-field-content'
                      name='desc'
                      value={inputs.desc}
                      onChange={(e) => handleChange(e)}

                    />
                    <svg onClick={() => handleClearInput('desc')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                </div>
                <div className='screening-input-minors'>
                  <div className='screening-input-field-container' style={{ width: '50%' }}>
                    <input
                      id='origin'
                      type='text'
                      placeholder='Optional: Enter Country of Origin'
                      className='screening-input-field-content'
                      name='origin'
                      value={inputs.origin}
                      onChange={(e) => handleChange(e)}

                    />
                    <svg onClick={() => handleClearInput('origin')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                  <div className='screening-input-field-container' style={{ width: '50%' }}>
                    <input
                      id='destination'
                      type='text'
                      placeholder='Optional: Enter Country of Destination'
                      className='screening-input-field-content'
                      name='destination'
                      value={inputs.destination}
                      onChange={(e) => handleChange(e)}

                    />
                    <svg onClick={() => handleClearInput('destination')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                </div>
              </div>}
          </div>
        </>
      )}


    </>
  );
};
export default FileStep;
